import FroalaEditor from 'froala-editor/js/froala_editor.pkgd.min.js';

const toolbarButtons = [
  ['undo', 'redo'],
  ['paragraphFormat', 'fontSize'],
  ['bold', 'italic'],
  ['align', 'insertLink', 'insertImage', 'insertTable'],
  ['html']
]

const toolbarButtonsXS = [
  ['undo', 'redo'],
  ['paragraphFormat', 'fontSize']
]

new FroalaEditor('.wysiwyg-editor', {
  inlineMode: false,
  heightMin: '200px',
  toolbarSticky: true,
  toolbarButtons: toolbarButtons,
  toolbarButtonsXS: toolbarButtonsXS,
  charCounterCount: false,
  key: process.env.FROALA_LICENSE
})
